<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
  >
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>
    <div
      data-qa="prescription-appointment"
      class="kds-main-wrapper"
    >
      <div class="kds-content-block">
        <p
          class="kds-typography-title-xlarge"
          data-qa="header"
          v-html="headerText"
        />
        <p
          class="kds-typography-paragraph-large kds-typography-normal-white-space"
          data-qa="description"
          v-html="descriptionText"
        />
      </div>

      <img
        :src="prescriptionSampleImageSrc"
        alt="Prescription Check Banner"
      />
      <p
        class="kds-typography-paragraph-large"
        data-qa="secondary-description"
        v-html="secondaryDescriptionText"
      />
    </div>
    <template #actions>
      <BaseButton
        :text="$t('eu__prescription_appointment__primary_cta')"
        data-qa="submit"
        @click="handleSubmitEvent"
      />
      <BaseButton
        variant="outlined"
        :text="$t('eu__prescription_appointment__secondary_cta')"
        data-qa="cancel"
        @click="handleCancelEvent"
      />
    </template>
  </ResponsiveLayout>
  <PrescriptionSupportModal
    ref="supportModalRef"
    show-skip
    @skip="navigateNext('supportSkipped')"
  />
</template>

<script setup>
import { computed, ref } from 'vue'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { useI18n } from 'petite-vue-i18n'
import env from '@shared/env.js'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import * as apiRequest from '@shared/api-endpoints/index.js'
import prescriptionSampleCopd from '@shared/assets/img/prescription_sample_copd_x4.png'
import prescriptionSampleMsk from '@shared/assets/img/prescription_sample_msk_x4.png'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useNavigation from '@eu/app/composables/useNavigation'
import ROUTE from '@eu/app/router/appModule/names'
import PrescriptionSupportModal from '@eu/app/components/PrescriptionSupportModal.vue'

const { t } = useI18n()
const corporateStore = useCorporateStore()
const { progress } = useOnboardingProgress()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.PRESCRIPTION_APPOINTMENT,
)
const supportModalRef = ref(null)

const corporate = computed(() => corporateStore.corporate)
const appName = computed(() => t('eu__generic__app'))
const headerText = computed(() => t('eu__prescription_appointment__header'))
const descriptionText = computed(() =>
  t('eu__prescription_appointment__description', { app_name: appName.value }),
)
const prescriptionSampleImageSrc = computed(() =>
  env.VITE_DISEASE === 'copd' ? prescriptionSampleCopd : prescriptionSampleMsk,
)
const secondaryDescriptionText = computed(() =>
  t('eu__prescription_appointment__secondary_description', {
    app_name: appName.value,
  }),
)

const handleCancelEvent = () => {
  Tracker.trackButtonSelect(
    'continue_appointment',
    'signup_diga_prescription_appointment',
  )
  apiRequest.sendSubscriptionActivationEntry({
    type: 'user_has_appointment',
  })
  // in-app users are returned into the app by the download-link guard
  navigateNext('hasAppointment')
}

const handleSubmitEvent = () => {
  Tracker.trackButtonSelect(
    'no_appointment',
    'signup_diga_prescription_appointment',
  )
  apiRequest.sendSubscriptionActivationEntry({
    type: 'user_has_no_appointment',
  })
  supportModalRef.value.open()
}
</script>
